import playerListStore from '@modules/player/player-list-store';
import playerViewStore from '@modules/player/player-view-store';
import playerImporterStore from '@modules/player/player-importer-store';
import playerFormStore from '@modules/player/player-form-store';
import playerDestroyStore from '@modules/player/player-destroy-store';
import playerUpdateTeamsStore from '@modules/player/player-update-teams-store';
import playerViewInscriptionsStore from '@modules/player/player-view-inscriptions-store';

export default {
  namespaced: true,

  modules: {
    destroy: playerDestroyStore,
    form: playerFormStore,
    list: playerListStore,
    view: playerViewStore,
    viewInscriptions: playerViewInscriptionsStore,
    importer: playerImporterStore,
    updateTeams: playerUpdateTeamsStore,
  },
};
